import script from "./boardListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardListPage.vue?vue&type=script&setup=true&lang=js"

import "./boardListPage.vue?vue&type=style&index=0&id=41e3a91c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e3a91c"]])

export default __exports__